import { render, staticRenderFns } from "./DiagDescribe.vue?vue&type=template&id=04ccd7b8&scoped=true"
import script from "./DiagDescribe.vue?vue&type=script&lang=js"
export * from "./DiagDescribe.vue?vue&type=script&lang=js"
import style0 from "./DiagDescribe.vue?vue&type=style&index=0&id=04ccd7b8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ccd7b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04ccd7b8')) {
      api.createRecord('04ccd7b8', component.options)
    } else {
      api.reload('04ccd7b8', component.options)
    }
    module.hot.accept("./DiagDescribe.vue?vue&type=template&id=04ccd7b8&scoped=true", function () {
      api.rerender('04ccd7b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/DiagDescribe.vue"
export default component.exports